import { render, staticRenderFns } from "./UserSiteDocumentsTab.vue?vue&type=template&id=abd71df8"
import script from "./UserSiteDocumentsTab.vue?vue&type=script&lang=js"
export * from "./UserSiteDocumentsTab.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/pages/user-site/user-site-documents-tab.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports